// src/pages/Services.js (GÜNCEL)
import React from "react";
import SERVICES from "../data/services.json";
import ServiceIcon from "../components/ServiceIcon";

export default function Services() {
  const handleCardClick = (key) => {
    window.location.href = `/services/${key}`;
  };

  return (
    <section className="section">
      <div className="container">
        <header className="section-head">
          <h1 className="page-title">Hizmetlerimiz</h1>
          <p className="page-subtitle">
            Sahada hız, güvenlik ve şeffaflık odaklı çözümler.
          </p>
        </header>

        <div className="services-grid">
          {SERVICES.map((s) => (
            <article
              key={s.key}
              className="service-card"
              onClick={() => handleCardClick(s.key)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && handleCardClick(s.key)}
            >
              <div className="service-media">
                <img
                  src={s.img}
                  alt={`${s.title} görseli`}
                  loading="lazy"
                  decoding="async"
                />
                <div className="service-icon">
                  <ServiceIcon name={s.key} />
                </div>
              </div>
              <div className="service-body">
                <h3 className="service-title">{s.title}</h3>
                <p className="service-desc">{s.desc}</p>
                <div className="service-actions">
                  <a className="btn ghost" href={`/services/${s.key}`}>
                    Detaya git
                  </a>
                  {/* <a className="btn primary" href="/contact#form">Teklif Al</a> */}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div id="quote" className="cta services-cta">
          <h3>Projeniz için doğru çözüm</h3>
          <p>Kısa bilgi verin, aynı gün fiyat teklifimizi iletelim.</p>
          <a className="btn primary" href="/contact#form">
            Hemen İletişim
          </a>
        </div>
      </div>
    </section>
  );
}